import { add, Duration, millisecondsToSeconds } from "date-fns";
import { flow, Duration as EffectDuration, pipe } from "effect";

export const durationToMilliseconds = (duration: Duration) =>
  add(0, duration).valueOf();

export const durationToSeconds = flow(
  durationToMilliseconds,
  millisecondsToSeconds
);

export function getCurrentTimestamp(): bigint {
  return pipe(
    Date.now(),
    EffectDuration.millis,
    EffectDuration.toSeconds,
    Math.round,
    BigInt
  );
}
